module.exports = __webpack_public_path__ + "media/application/images/svgs/shopping-cart-c6f1124a9848f9f24a56fc29748e506f.svg";